/** Même arrondi après remise que CatalogRule/Apply : 50 centimes vers le bas. */
export function applyMarketingRounding(price) {
    const cents = Math.round(Math.max(0, Number(price)) * 100);
    return Math.floor(cents / 100) + (cents % 100 > 50 ? 1 : 0);
}

export function roundsSalesChannel(code) {
    return ['SI', 'BU', 'default', 'bureau'].includes(code);
}

export function discountedPrice(original, action, discount, roundToEuro = true) {
    let total = Number(original);
    discount = Number(discount);
    switch (action) {
        case 'by_percent': total *= 1 - discount / 100; break;
        case 'to_percent': total *= discount / 100; break;
        case 'by_fixed': total = Math.max(0, total - discount); break;
        case 'to_fixed': total = Math.min(total, discount); break;
    }
    return roundToEuro ? applyMarketingRounding(total) : Math.round(Math.max(0, total) * 100) / 100;
}

/** Calcule la remise sur le total des tours, avant un unique arrondi. */
export function stagePrice(price, tours = price.nb_tour_min ?? 1, roundToEuro = true) {
    const extra = Math.max(0, Number(tours) - Number(price.nb_tour_min ?? tours));
    const rule = price.rule;
    if (rule && price.old_montant_ttc != null) {
        const original = Number(price.old_montant_ttc)
            + extra * Number(price.old_montant_ttc_par_tour ?? price.montant_ttc_par_tour ?? 0);
        return discountedPrice(original, rule.action_type, rule.discount_amount, roundToEuro);
    }
    const total = Number(price.montant_ttc) + extra * Number(price.montant_ttc_par_tour ?? 0);
    return price.promo && roundToEuro ? applyMarketingRounding(total) : total;
}
